import i18n, { ParseKeys } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./en.json";
import fr from "./fr.json";

export const resources = {
  en: {
    translation: en,
  },
  fr: {
    translation: fr,
  },
} as const;

void i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    compatibilityJSON: "v3",
    debug: false,
    resources,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export type I18nKeyType = ParseKeys;

export { i18n };
